import { render, staticRenderFns } from "./AccountRegPopup.vue?vue&type=template&id=f9388b96&"
import script from "./AccountRegPopup.vue?vue&type=script&lang=js&"
export * from "./AccountRegPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports